import React, { useEffect, useRef, useState } from 'react'
import { motion, useInView, animate } from 'motion/react'
import headerVideo from '../../assets/videos/headerVideo.mp4'
import headerVideoMobile from '../../assets/videos/headerVideoMobile.mp4'
import { statsData } from '../../components/sections/stats/Stats'

function Counter({ value, suffix = '', start }) {
  const [display, setDisplay] = useState(0)

  useEffect(() => {
    if (!start) return
    const controls = animate(0, value, {
      duration: 1.4,
      ease: 'easeOut',
      onUpdate: (v) => setDisplay(Math.floor(v)),
    })
    return () => controls.stop()
  }, [start, value])

  return (
    <span>
      {display}
      {suffix}
    </span>
  )
}

export default function Header() {
  const ref = useRef(null)
  const inView = useInView(ref, { amount: 0.35, once: true })

  return (
    <div className='relative pt-[70px]' ref={ref}>
      <video src={headerVideo} autoPlay muted loop className='w-full object-cover hidden md:block' />
      <video src={headerVideoMobile} autoPlay muted loop className='w-full object-cover block md:hidden' />

      {/* Stats overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/75 via-slate-900/45 to-slate-950/75 pointer-events-none" />
      {/* <div className="absolute inset-0 flex items-center justify-center px-4 pt-20 md:pt-0"> */}
        {/* <div className="max-w-6xl w-full text-white">
          <div className="text-center mb-8 sm:mb-10">
            <h2 className="text-3xl sm:text-4xl font-extrabold">الملتـقى فـي أرقــام</h2>
          </div>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-center">
            {statsData.map((item) => (
              <motion.div
                key={item.title}
                className="rounded-2xl lg:w-[18%] md:w-[25%] w-[40%] bg-white/10 border border-white/15 backdrop-blur-md px-3 py-4 sm:px-4 sm:py-5 shadow-[0_20px_60px_-30px_rgba(0,0,0,0.6)]"
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
              >
                <p className="text-3xl sm:text-4xl font-extrabold text-sky-300 mb-1">
                  <Counter value={item.value} suffix={item.suffix} start={inView} />
                </p>
                <p className="text-sm sm:text-base font-semibold text-white/90 leading-snug">{item.title}</p>
              </motion.div>
            ))}
          </div>
        </div> */}
      {/* </div> */}
    </div>
  )
}
